module.exports = __webpack_public_path__ + "img/buger+mg.b7c75d8b.png";